import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../../../utils/axios";

const initialState = {
  data: [],
  loading: false,
  message: "",
  completed: false,
  hasError: false,
};

export const fetchAmazonVendorTopCategoriesData = createAsyncThunk(
  "amazonvendor/fetchAmazonVendorTopCategoriesData",
  async ({ params }) => {
    const response = await axiosInstance.request({
      url: `/amazonvendor/topcategories`,
      method: `GET`,
      params: params,
    });
    return response;
  }
);

const amazonVendorTopCategoriesSlice = createSlice({
  name: "amazonvendor",
  initialState,
  reducers: {
    clearData: () => {
      return initialState;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchAmazonVendorTopCategoriesData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAmazonVendorTopCategoriesData.fulfilled, (state, action) => {
        state.loading = false;
        state.completed = true;
        state.data = action.payload.data;
      })
      .addCase(fetchAmazonVendorTopCategoriesData.rejected, (state, action) => {
        state.loading = false;
        state.completed = true;
        state.hasError = true;
        state.message = action.error.message;
      });
  },
});

const AmazonVendorTopCategoriesReducer = amazonVendorTopCategoriesSlice.reducer;

export default AmazonVendorTopCategoriesReducer;

export const amazonVendorTopCategoriesAction = amazonVendorTopCategoriesSlice.actions;
